var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import { companies } from '@debbie/cortex/dist/api';
import SearchInput from './SearchInput';
const CompanySearch = (props) => {
    const lang = useSelector((s) => s.lang);
    const searchAll = (q) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield companies.search(q);
        return result
            ? result.map((company) => ({
                key: company.centralRegisterId,
                heading: company.name,
                subheading: `CVR: DK${company.centralRegisterId}`,
                small: company.status,
                returnData: company,
            }))
            : [];
    });
    return (React.createElement("div", { className: props.className },
        React.createElement(SearchInput, { disabled: props.disabled, autofocus: props.autofocus, static: props.value, onRemoveStatic: props.onRemoveStatic, placeholder: props.placeholder || lang.inputs.searchForCompany, searchAll: (q) => (q ? searchAll(q) : []), onSelect: props.onChange })));
};
export default CompanySearch;
//# sourceMappingURL=CompanySearch.js.map